module.exports = __webpack_public_path__ + "static/media/faq-1500.a7818b4e.jpg";